document.addEventListener("DOMContentLoaded", function() {
  var youtubeVideos = document.querySelectorAll(".youtube-video");

  youtubeVideos.forEach(function(video) {
    var videoId = video.dataset.videoId;
    video.style.position = "relative";
    video.style.width = "100%"; // Largeur à 100% pour couvrir le conteneur parent

    var img = document.createElement("img");
    img.src = "https://img.youtube.com/vi/" + videoId + "/maxresdefault.jpg";
    img.style.cursor = "pointer";
    img.style.width = "100%";
    img.style.height = "auto"; // Hauteur auto pour conserver le ratio
    img.alt = "YouTube Video Preview";
    video.appendChild(img);

    var playButton = document.createElement("div");
    playButton.style.backgroundImage = 'url("https://cdn.shopify.com/s/files/1/0430/2710/3908/files/youtube-play-bouton.png?v=1705192979")';
    playButton.style.backgroundSize = "64px 64px";
    playButton.style.backgroundRepeat = "no-repeat";
    playButton.style.backgroundPosition = "center";
    playButton.style.position = "absolute";
    playButton.style.top = "50%";
    playButton.style.left = "50%";
    playButton.style.transform = "translate(-50%, -50%)";
    playButton.style.zIndex = "100";
    playButton.style.height = "64px";
    playButton.style.width = "64px";
    video.appendChild(playButton);

    function loadVideo() {
      var iframe = document.createElement("iframe");
      iframe.setAttribute("src", "https://www.youtube.com/embed/" + videoId + "?autoplay=1");
      iframe.style.height = "100%"; // Hauteur à 100% du conteneur parent
      iframe.style.width = "100%"; // Largeur à 100% du conteneur parent
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allowfullscreen", "");
      iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share");
      video.replaceChild(iframe, img);
      video.removeChild(playButton);
    }

    img.addEventListener("click", loadVideo);
    playButton.addEventListener("click", loadVideo);
  });
});
